import type { AttitudeAnswer, ParticipantStance } from "../types/study";

export const ATTITUDE_ITEMS = [
  {
    itemId: "perceived_gender_equality",
    label: "你觉得当下中国社会的男女平权程度如何？",
    lowLabel: "非常不平等",
    highLabel: "非常平等",
    scored: false
  },
  {
    itemId: "endorsement_feminism_development",
    label: "你对中国女权主义当下的发展的认同程度是？",
    lowLabel: "完全不认同",
    highLabel: "完全认同",
    scored: true
  },
  {
    itemId: "support_feminism_development",
    label: "我总体上支持当下中国女权主义的发展。",
    lowLabel: "非常不同意",
    highLabel: "非常同意",
    scored: true
  },
  {
    itemId: "feminism_importance",
    label: "支持或反对女权主义在我眼里很重要。",
    lowLabel: "完全不重要",
    highLabel: "非常重要",
    scored: false
  },
  {
    itemId: "attitude_certainty",
    label: "我对自己关于女权的态度立场很确定。",
    lowLabel: "完全不确定",
    highLabel: "非常确定",
    scored: false
  },
  {
    itemId: "necessity_of_women_rights",
    label: "我认为当下继续推动女性权益是必要的。",
    lowLabel: "非常不同意",
    highLabel: "非常同意",
    scored: true
  }
] as const;

function hashSeed(input: string): number {
  let hash = 2166136261;
  for (let index = 0; index < input.length; index += 1) {
    hash ^= input.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

function resolveTieStance(seed: string): ParticipantStance {
  return hashSeed(seed) % 2 === 0 ? "feminist_leaning" : "male_leaning";
}

export function scoreAttitude(answers: AttitudeAnswer[], tieBreakerSeed = ""): {
  stance: ParticipantStance;
  intensity: number;
} {
  const byId = new Map(answers.map((answer) => [answer.itemId, answer.value]));
  const scoredItems = ATTITUDE_ITEMS.filter((item) => item.scored);
  const rawScores = scoredItems.map((item) => byId.get(item.itemId) ?? 4);
  const mean = rawScores.reduce((sum, value) => sum + value, 0) / rawScores.length;

  let stance: ParticipantStance;
  if (mean > 4) {
    stance = "feminist_leaning";
  } else if (mean < 4) {
    stance = "male_leaning";
  } else {
    stance = resolveTieStance(tieBreakerSeed);
  }

  return {
    stance,
    intensity: Math.abs(mean - 4)
  };
}

export function provisionalDetectedTargetFallacy(logicScore: number): number {
  // Placeholder only: formal DV threshold must be set before pilot data collection.
  return logicScore <= 2 ? 1 : 0;
}
